<template>
  <div id="app">
    <navbar></navbar>
    <div class="container">
      <api-config></api-config>
      <router-view v-if="apiConfigValid"></router-view>
      <api-request-response v-if="apiConfigValid"></api-request-response>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import ApiConfig from './components/ApiConfig'
import ApiRequestResponse from './components/ApiRequestResponse'
export default {
  name: 'app',
  components: { Navbar, ApiConfig, ApiRequestResponse },
  computed: {
    apiConfigValid () {
      return this.$store.getters.apiConfigValid
    }
  }
}
</script>

<style lang="scss">
//$container-max-widths: (sm: 540px, md: 720px, lg: 960px, xl: 1440px);
$font-family-sans-serif: 'Montserrat', -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !default;
@import '../node_modules/bootstrap/scss/bootstrap';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.call-name {
  margin-bottom: 1rem;
  small {
    margin-left: 2rem;
  }
}
.results .result-link {
  margin-left: 2rem;
}
</style>



// WEBPACK FOOTER //
// App.vue?7c91e725